var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-nav-item-box",class:[_vm.type === 'succinct' ? 'succinct' : '']},_vm._l((_vm.tabItemArr),function(tabItem,index){return _c('div',{key:index,class:[
      'tab-nav-item',
      tabItem.name === _vm.activeName ? 'highLight' : '',
      tabItem.disabled ? 'isForbiddenItem' : '',
      _vm.type === 'succinct' ? 'succinct-item' : ''
    ],on:{"click":function($event){return _vm.changeActiveName(tabItem)}}},[_vm._v(" "+_vm._s(tabItem.label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }